// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/webhook.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateWebhookRequest, CreateWebhookResponse, DeleteWebhookRequest, DeleteWebhookResponse, GetWebhookRequest, GetWebhookResponse, GetWebhookSecretRequest, GetWebhookSecretResponse, ListWebhooksRequest, ListWebhooksResponse, ListWebhookWorkflowsRequest, ListWebhookWorkflowsResponse, RotateWebhookSecretRequest, RotateWebhookSecretResponse, UpdateWebhookRequest, UpdateWebhookResponse } from "./webhook_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.WebhookService
 */
export const WebhookService = {
  typeName: "gitpod.v1.WebhookService",
  methods: {
    /**
     * Creates a new webhook for receiving SCM events.
     *
     * Use this method to:
     * - Set up webhooks for repository or organization events
     * - Configure webhook scope and provider
     *
     * ### Examples
     *
     * - Create repository webhook:
     *
     *   Creates a webhook scoped to a specific repository.
     *
     *   ```yaml
     *   name: "My Repo Webhook"
     *   type: WEBHOOK_TYPE_SCM_REPOSITORY
     *   scope: "gitpod-io/gitpod"
     *   provider: WEBHOOK_PROVIDER_GITHUB
     *   ```
     *
     * - Create organization webhook:
     *
     *   Creates a webhook scoped to all repositories in an organization.
     *
     *   ```yaml
     *   name: "Org Webhook"
     *   type: WEBHOOK_TYPE_SCM_ORGANIZATION
     *   scope: "gitpod-io"
     *   provider: WEBHOOK_PROVIDER_GITHUB
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.CreateWebhook
     */
    createWebhook: {
      name: "CreateWebhook",
      I: CreateWebhookRequest,
      O: CreateWebhookResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific webhook.
     *
     * Use this method to:
     * - View webhook configuration
     * - Check webhook URL
     * - See bound workflow count
     *
     * ### Examples
     *
     * - Get webhook details:
     *
     *   Retrieves information about a specific webhook.
     *
     *   ```yaml
     *   webhookId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.GetWebhook
     */
    getWebhook: {
      name: "GetWebhook",
      I: GetWebhookRequest,
      O: GetWebhookResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists webhooks with optional filtering.
     *
     * Use this method to:
     * - View all webhooks in an organization
     * - Filter webhooks by type or provider
     *
     * ### Examples
     *
     * - List all webhooks:
     *
     *   Shows all webhooks with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.ListWebhooks
     */
    listWebhooks: {
      name: "ListWebhooks",
      I: ListWebhooksRequest,
      O: ListWebhooksResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a webhook's configuration.
     *
     * Use this method to:
     * - Change webhook name or description
     * - Change webhook scope (the target repository or organization)
     *
     * Note: The webhook type and provider cannot be changed after creation.
     *
     * ### Examples
     *
     * - Update webhook name:
     *
     *   Changes the webhook's display name.
     *
     *   ```yaml
     *   webhookId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   name: "Updated Webhook Name"
     *   ```
     *
     * - Update webhook scope:
     *
     *   Changes the webhook's target repository.
     *
     *   ```yaml
     *   webhookId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   scope: "gitpod-io/new-repo"
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.UpdateWebhook
     */
    updateWebhook: {
      name: "UpdateWebhook",
      I: UpdateWebhookRequest,
      O: UpdateWebhookResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a webhook permanently.
     *
     * Use this method to:
     * - Remove unused webhooks
     * - Clean up webhook configurations
     *
     * ### Examples
     *
     * - Delete webhook:
     *
     *   Permanently removes a webhook.
     *
     *   ```yaml
     *   webhookId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.DeleteWebhook
     */
    deleteWebhook: {
      name: "DeleteWebhook",
      I: DeleteWebhookRequest,
      O: DeleteWebhookResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the webhook secret for signature validation.
     *
     * This operation is audited for security purposes.
     *
     * Use this method to:
     * - Retrieve webhook secret for SCM configuration
     * - Verify webhook signatures
     *
     * ### Examples
     *
     * - Get webhook secret:
     *
     *   Retrieves the webhook secret.
     *
     *   ```yaml
     *   webhookId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.GetWebhookSecret
     */
    getWebhookSecret: {
      name: "GetWebhookSecret",
      I: GetWebhookSecretRequest,
      O: GetWebhookSecretResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Rotates the webhook secret.
     *
     * Use this method to:
     * - Generate a new webhook secret
     * - Invalidate the old webhook secret
     *
     * ### Examples
     *
     * - Rotate webhook secret:
     *
     *   Generates a new webhook secret.
     *
     *   ```yaml
     *   webhookId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.RotateWebhookSecret
     */
    rotateWebhookSecret: {
      name: "RotateWebhookSecret",
      I: RotateWebhookSecretRequest,
      O: RotateWebhookSecretResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists workflows bound to a webhook.
     *
     * Use this method to:
     * - View all workflows triggered by a webhook
     * - Check workflow bindings
     *
     * ### Examples
     *
     * - List webhook workflows:
     *
     *   Shows all workflows bound to a webhook.
     *
     *   ```yaml
     *   webhookId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.WebhookService.ListWebhookWorkflows
     */
    listWebhookWorkflows: {
      name: "ListWebhookWorkflows",
      I: ListWebhookWorkflowsRequest,
      O: ListWebhookWorkflowsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

